import React, { Fragment, useEffect, useState } from 'react';
import GuarantorSwitchBox from './GuarantorSwitchBox';
import { Badge, Button, Col, Popover, Row } from 'antd';
import { objToArray } from '../../common/Utilities';
import { useNavigate } from 'react-router-dom';

const GuarantorDetailsComponent = () => {
    const data = JSON.parse(localStorage.getItem('guarantor_details'));
    const [guarantorDocuments, setGuarantorDocuments] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        let dataDocuments = [];
        if (data != undefined) {
            dataDocuments = objToArray(data?.guarantor_docs);
            setGuarantorDocuments(dataDocuments);
        }
    },)
    return (
        data != undefined &&
        <div className='m-5 p-5'>
            <p className='text-[15px] font-[600] mb-5'>Guarantor Details</p>
            <Fragment>
                <Row gutter={[24, 24]}>
                    <Col xs={24} sm={24} md={12} lg={12}>
                        <Row gutter={[16, 16]} >
                            <Col xs={24} sm={24} md={12} lg={12}>
                                <p className='detail-label'>
                                    Applying As:
                                </p>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>
                                <p>
                                    {data.guarantor_type}
                                </p>
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]} >
                            <Col xs={24} sm={24} md={12} lg={12}>
                                <p className='detail-label'>
                                    Name:
                                </p>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>{data.personal_details?.name ? data.personal_details?.name : data.personal_details?.company_name}</Col>
                        </Row>
                        <Row gutter={[16, 16]} >
                            <Col xs={24} sm={24} md={12} lg={12}>
                                <p className='detail-label'>
                                    Email:
                                </p>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>{data.personal_details?.email}</Col>
                        </Row>
                        {data.personal_details?.gender &&
                            <Row gutter={[16, 16]} >
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <p className='detail-label'>
                                        Gender:
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>{data.personal_details?.gender}</Col>
                            </Row>
                        }
                        {data.personal_details?.nationality &&
                            <Row gutter={[16, 16]} >
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <p className='detail-label'>
                                        Nationality/Country:
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'> {data.personal_details?.nationality}</Col>
                            </Row>
                        }
                        {data.personal_details?.passport_expiry_date &&
                            <Row gutter={[16, 16]} >
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <p className='detail-label'>
                                        Passport Expiry:
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>{data.personal_details?.passport_expiry_date}</Col>
                            </Row>
                        }
                        {data.personal_details?.office &&
                            <Row gutter={[16, 16]} >
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <p className='detail-label'>
                                        Office No:
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>{data.personal_details?.office}</Col>
                            </Row>
                        }
                        {data.personal_details?.home_no &&
                            <Row gutter={[16, 16]} >
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <p className='detail-label'>
                                        Home No:
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>{data.personal_details?.home_no}</Col>
                            </Row>
                        }
                        <Row gutter={[16, 16]} >
                            <Col xs={24} sm={24} md={12} lg={12}>
                                <p className='detail-label'>
                                    Address:
                                </p>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>{data.personal_details?.home_address ? data.personal_details?.home_address : data.personal_details?.company_address}</Col>
                        </Row>
                        {data.personal_details?.home_address_same_as_mailing == 1 || data.personal_details?.company_address_same_as_mailing == 1 &&
                            <Row gutter={[16, 16]} >
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <p className='detail-label'>
                                        Mailing Address:
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>{data.personal_details?.home_address ? data.personal_details?.mailing_home_address : data.personal_details?.mailing_company_address}</Col>
                            </Row>
                        }
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12}>
                        {((data.personal_details?.guarantor_type == 'individual') && (data.personal_details?.guarantor_nric != '')) &&
                            <Row gutter={[16, 16]} >
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <p className='detail-label'>
                                        NRIC (Last 4 Characters):
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>{data.personal_details?.guarantor_nric}</Col>
                            </Row>
                        }
                        {data.personal_details?.uen_acra_no != '' &&
                            <Row gutter={[16, 16]} >
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <p className='detail-label'>
                                        UEN/ACRA (Last 4 Characters):
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>{data.personal_details?.uen_acra_no}</Col>
                            </Row>
                        }
                        {data.personal_details?.dob &&
                            <Row gutter={[16, 16]} >
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <p className='detail-label'>
                                        Date of Birth:
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>{data.personal_details?.dob}</Col>
                            </Row>
                        }
                        {data.personal_details?.date_of_incorporation &&
                            <Row gutter={[16, 16]} >
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <p className='detail-label'>
                                        Date of Incorporation:
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>{data.personal_details?.date_of_incorporation}</Col>
                            </Row>
                        }
                        {data.personal_details?.marital_status &&
                            <Row gutter={[16, 16]} >
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <p className='detail-label'>
                                        Marital Status:
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>{data.personal_details?.marital_status}</Col>
                            </Row>
                        }
                        {data.personal_details?.name_of_spouse &&
                            <Row gutter={[16, 16]} >
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <p className='detail-label'>
                                        Name of Spouse:
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>{data.personal_details?.name_of_spouse}</Col>
                            </Row>
                        }
                        {data.personal_details?.residence_type &&
                            <Row gutter={[16, 16]} >
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <p className='detail-label'>
                                        Residence:
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>{data.personal_details?.residence_type}</Col>
                            </Row>
                        }
                        {data.personal_details?.mobile_no &&
                            <Row gutter={[16, 16]} >
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <p className='detail-label'>
                                        Mobile No:
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>{data.personal_details?.mobile_no}</Col>
                            </Row>
                        }
                    </Col>
                </Row>
                <Row gutter={[24, 24]} className='mt-5'>
                    {data?.employement_details &&
                        data?.employement_details?.employment_type != 'Unemployed' ?
                        <Fragment>
                            <Col xs={24} sm={24} md={12} lg={12}>
                                <Row gutter={[16, 16]} >
                                    <Col xs={24} sm={24} md={12} lg={12}>
                                        <p className='detail-label'>
                                            Employment:
                                        </p>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>
                                        <p>
                                            {data.personal_details?.employement_details?.employment_type}
                                        </p>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]} >
                                    <Col xs={24} sm={24} md={12} lg={12}>
                                        <p className='detail-label'>
                                            Employment (if others):
                                        </p>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>Hyundai Avante 1.6A GLS S</Col>
                                </Row>
                                <Row gutter={[16, 16]} >
                                    <Col xs={24} sm={24} md={12} lg={12}>
                                        <p className='detail-label'>
                                            Income Type:
                                        </p>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>2018</Col>
                                </Row>
                                <Row gutter={[16, 16]} >
                                    <Col xs={24} sm={24} md={12} lg={12}>
                                        <p className='detail-label'>
                                            Monthly Income:
                                        </p>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'> 12 MAR 2033</Col>
                                </Row>
                                <Row gutter={[16, 16]} >
                                    <Col xs={24} sm={24} md={12} lg={12}>
                                        <p className='detail-label'>
                                            Employer Name:
                                        </p>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'> Singapore NRIC</Col>
                                </Row>
                                <Row gutter={[16, 16]} >
                                    <Col xs={24} sm={24} md={12} lg={12}>
                                        <p className='detail-label'>
                                            Employer Address:
                                        </p>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>498G</Col>
                                </Row>
                                <Row gutter={[16, 16]} className='mb-1 mt-5'>
                                    <Col xs={24} sm={24} md={12} lg={12}>
                                        <p className='detail-label'>
                                            Prev. Occupation:
                                        </p>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>Yes, remains as OPC</Col>
                                </Row>
                                <Row gutter={[16, 16]} >
                                    <Col xs={24} sm={24} md={12} lg={12}>
                                        <p className='detail-label'>
                                            Prev. Employer Name:
                                        </p>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>Yes, remains as OPC</Col>
                                </Row>
                                <Row gutter={[16, 16]} >
                                    <Col xs={24} sm={24} md={12} lg={12}>
                                        <p className='detail-label'>
                                            Employer Address:
                                        </p>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>Yes, remains as OPC</Col>
                                </Row>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12}>
                                <Row gutter={[16, 16]} >
                                    <Col xs={24} sm={24} md={12} lg={12}>
                                        <p className='detail-label'>
                                            Occupation:
                                        </p>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>SGT8888H</Col>
                                </Row>
                                <Row gutter={[16, 16]} >
                                    <Col xs={24} sm={24} md={12} lg={12}>
                                        <p className='detail-label'>
                                            No. of Employee (if any):
                                        </p>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>SGT8888H</Col>
                                </Row>
                                <Row gutter={[16, 16]} >
                                    <Col xs={24} sm={24} md={12} lg={12}>
                                        <p className='detail-label'>
                                            Type of Industry:
                                        </p>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>SGT8888H</Col>
                                </Row>
                                <Row gutter={[16, 16]} >
                                    <Col xs={24} sm={24} md={12} lg={12}>
                                        <p className='detail-label'>
                                            Other Monthly Income:
                                        </p>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>SGT8888H</Col>
                                </Row>
                                <Row gutter={[16, 16]} >
                                    <Col xs={24} sm={24} md={12} lg={12}>
                                        <p className='detail-label'>
                                            Length of Service:
                                        </p>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>12 MAR 2033</Col>
                                </Row>
                                <Row gutter={[16, 16]} className='mb-1 mt-[40px]'>
                                    <Col xs={24} sm={24} md={12} lg={12}>
                                        <p className='detail-label'>
                                            Length of Service:
                                        </p>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>12 MAR 2033</Col>
                                </Row>
                            </Col>
                        </Fragment>
                        :
                        <Col xs={24} sm={24} md={12} lg={12}>

                            <Row gutter={[16, 16]} >
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <p className='detail-label'>
                                        Employment:
                                    </p>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} className='text-[12px] font-[500] mb-3'>
                                    <p>
                                        {data?.employement_details?.employment_type}
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                    }
                </Row>
                <p className='mt-5 text-[15px] font-[600]'>Document(s) Uploaded </p>
                <Row gutter={[16, 16]} className='mb-1 mt-4'>
                    {guarantorDocuments != undefined && guarantorDocuments.length > 0 &&
                        guarantorDocuments.map((doc, index) => {
                            const key = Object.keys(doc)[0];
                            const valueLength = doc[key].length;
                            console.log(key);
                            console.log(valueLength);

                            let words = key.split('_');
                            for (let i = 0; i < words.length; i++) {
                                words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
                            }
                            let result = words.join(' ');

                            if (result.length <= 4) {
                                result = result.toUpperCase();
                            }

                            // Determine if a new row should start
                            const shouldStartNewRow = index > 0 && index % 4 === 0;
                            return (
                                <>
                                    {shouldStartNewRow && <div style={{ flexBasis: '100%', height: 0 }}></div>}
                                    <Col>
                                        <div className="sm:w-2/2 lg:w-4/4 mt-1 flex border rounded py-2 w-[250px] px-2">
                                            <img style={{ width: "15px", height: "15px" }} className='mr-3 mt-[2px]' src={'/images/' + key + ".png"} />
                                            <div className='w-full flex'>
                                                <div className='text-[13px] font-[500] text-[#0D062D]'>{result}</div>
                                            </div>
                                            <Popover content={"Coming soon"} className='mt-[-1px]'>
                                                <div>
                                                    <img src="/images/fi_info.svg" alt="info" className="inline-block cursor-pointer text-right" />
                                                </div>
                                            </Popover>
                                        </div>
                                        <div> <p className='text-left font-lato text-[12px] text-[500] text-instruction-grey opacity-60 mt-1'>{valueLength} {valueLength > 1 ? "File(s)" : "File"} </p></div>
                                    </Col>
                                </>
                            );
                        })
                    }
                </Row>
                <Row gutter={[16, 16]} className='mt-[150px]'>
                    <Col xs={24} sm={24} md={12} lg={12}>
                        <Button onClick={() => {
                            navigate('/case-detail-documents', { state: { type: "guarantor", documents: guarantorDocuments } });
                        }} className='min-[768px]:text-[14px] max-[768px]:text-[12px] mr-4' type='primary'>Download All Documents</Button>
                    </Col>
                </Row>
            </Fragment>
        </div>
    );
};

export default GuarantorDetailsComponent;